export const cardData = [
    {
        version:'workshopcard',
        name: 'Dobbelstenen',
        bymutext:'designed',
        slider1: '90',
        slider2: '30',
        slider3: '60',
        tags: ['Scratsj', 'Prosessing', 'een derde tag', 'vierde', 'vijfde'],
        icon1:'block',
        icon2:'none',
        icon3:'block',
        icon4:'none',
        time:'15 - 120',
        artistLinks:['www.ditishet.nl','www.lieke.nl','www.bart.nl','www.gratis.nl'],
        requestWorkshop:'inline-block',
        praktischeLinks:['www.test.nl'],
        bron:['loremipsumlalala'],
        color: '#6F3BFF',//purple
        text:'De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam . Nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam '
    }
    ,
    {
        version:'card',
        name: 'kaarten',
        bymutext:'designed',
        slider1: '60',
        slider2: '80',
        slider3: '40',
        tags: ['Scratsj', 'Prosessing', 'een derde tag'],
        icon1:'block',
        icon2:'none',
        icon3:'block',
        icon4:'none',
        time:'15 - 120',
        artistLinks:['www.ditishet.nl','www.lieke.nl','www.bart.nl','www.gratis.nl'],
        requestWorkshop:'none',
        praktischeLinks:['www.test.nl'],
        bron:['loremipsumlalala'],
        color: '#FF3956',//red
        text:'De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam . Nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam '
    }
    ,
    {
        version:'card',
        name: 'Coderen',
        bymutext:'tweaked',
        slider1: '60',
        slider2: '80',
        slider3: '40',
        tags: ['Scratsj', 'Prosessing', 'een derde tag', 'vierde', 'vijfde'],
        icon1:'none',
        icon2:'none',
        icon3:'block',
        icon4:'block',
        time:'15 - 120',
        artistLinks:['www.ditishet.nl','www.lieke.nl','www.bart.nl','www.gratis.nl'],
        requestWorkshop:'none',
        praktischeLinks:['www.test.nl'],
        bron:['loremipsumlalala'],
        color: '#FFCD2E',//yellow
        text:'De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam . Nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam '
    }
    ,
    {
        version:'workshopcard',
        name: 'GoTo opdracht',
        bymutext:'Workshop',
        slider1: '20',
        slider2: '40',
        slider3: '80',
        tags: ['Scratsj', 'Prosessing', 'een derde tag', 'vijf'],
        icon1:'none',
        icon2:'none',
        icon3:'block',
        icon4:'none',
        time:'12 - 100',
        artistLinks:['www.ditishet.nl','www.lieke.nl','www.bart.nl','www.gratis.nl'],
        requestWorkshop:'none',
        praktischeLinks:['www.test.nl'],
        bron:['loremipsumlalala'],
        color: '#38D7D7',//blue
        text:'De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam . Nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam '
    }
    ,
    {
        version:'card',
        name: 'Dobbelstenen',
        bymutext:'tweaked',
        slider1: '90',
        slider2: '30',
        slider3: '60',
        tags: ['Scratsj', 'Prosessing', 'een derde tag'],
        icon1:'block',
        icon2:'none',
        icon3:'block',
        icon4:'none',
        time:'15 - 120',
        artistLinks:['www.ditishet.nl','www.lieke.nl','www.bart.nl','www.gratis.nl'],
        requestWorkshop:'none',
        praktischeLinks:['www.test.nl'],
        bron:['loremipsumlalala'],
        color: '#38D7D7',//blue
        text:'De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam . Nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam '
    }
    ,
    {
        version:'card',
        name: 'kaarten',
        bymutext:'tweaked',
        slider1: '60',
        slider2: '80',
        slider3: '40',
        tags: ['Scratsj', 'Prosessing', 'een derde tag'],
        icon1:'block',
        icon2:'none',
        icon3:'block',
        icon4:'none',
        time:'15 - 120',
        artistLinks:['www.ditishet.nl','www.lieke.nl','www.bart.nl','www.gratis.nl'],
        requestWorkshop:'inline-block',
        praktischeLinks:['www.test.nl'],
        bron:['loremipsumlalala'],
        color: '#6F3BFF',//purple
        text:'De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam . Nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam '
    }
    ,
    {
        version:'card',
        name: 'Coderen',
        bymutext: 'designed',
        slider1: '60',
        slider2: '80',
        slider3: '40',
        tags: ['Scratsj', 'Prosessing', 'een derde tag'],
        icon1:'none',
        icon2:'none',
        icon3:'block',
        icon4:'block',
        time:'15 - 120',
        artistLinks:['www.ditishet.nl','www.lieke.nl','www.bart.nl','www.gratis.nl'],
        requestWorkshop:'none',
        praktischeLinks:['www.test.nl'],
        bron:['loremipsumlalala'],
        color: '#FFCD2E',//yellow
        text:'De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam . Nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam '
    }
    ,
    {
        version:'workshopcard',
        name: 'GoTo opdracht',
        bymutext:'workshop',
        slider1: '20',
        slider2: '40',
        slider3: '80',
        tags: ['Scratsj', 'Prosessing', 'een derde tag'],
        icon1:'block',
        icon2:'block',
        icon3:'block',
        icon4:'none',
        time:'12 - 100',
        artistLinks:['www.ditishet.nl','www.lieke.nl','www.bart.nl','www.gratis.nl'],
        requestWorkshop:'none',
        praktischeLinks:['www.test.nl'],
        bron:['loremipsumlalala'],
        color: '#6F3BFF',//purple
        text:'De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam . Nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam '
    }
    ,
    {
        version:'card',
        name: 'Coderen',
        bymutext:'tweaked',
        slider1: '60',
        slider2: '80',
        slider3: '40',
        tags: ['Scratsj', 'Prosessing', 'een derde tag'],
        icon1:'none',
        icon2:'none',
        icon3:'block',
        icon4:'block',
        time:'15 - 120',
        artistLinks:['www.ditishet.nl','www.lieke.nl','www.bart.nl','www.gratis.nl'],
        requestWorkshop:'none',
        praktischeLinks:['www.test.nl'],
        bron:['loremipsumlalala'],
        color: '#FF3956',//red
        text:'De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam . Nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. De computer voert sec instructies uit, ervaar met de klas hoe je zo muziek kan maken. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam '
    }
    ,
];